import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { BookV1 } from '@ilteducation/content-registry-types';
import useUploadMedia from '@/comp/use-upload-media';
import eventBus from '@/foundations/services/eventBus';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import useDownloadMedia from '@/comp/use-download-media';
import DropFile from '@/components/base/DropFile.vue';
import { downloadExternalContent } from '@/data-provider/refDataProvider';

type Props = {
  id: string;
  title?: string;
  item: BookV1;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'EPUBUploader',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title?: string;
  item: BookV1;
}

const { uploadInProgress, upload: uploadMedia } = useUploadMedia();
const { downloadMediaUrl } = useDownloadMedia();

const file = ref<File[]>([]);
const epubLink = ref('');
const acceptedFileType = 'application/epub+zip';
const isChanged = ref(false);

const changeHandler = (inputFile: File[]) => {
  if (!inputFile || !inputFile.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  file.value = inputFile;
};

const extractCover = ref(false);

const upload = () => {
  uploadMedia(props.id, file.value[0], { extractCover: extractCover.value });
};

const loadEPUBDownloadUrl = () => {
  downloadMediaUrl(props.id)
    .then((url) => {
      epubLink.value = url;
    })
    .catch((error) => {
      console.error(error.response);
      epubLink.value = '';
    });
};

eventBus.$on('mediaFragment.mediaUploaded', () => {
  const interval = setInterval(async () => {
    if (epubLink.value.length > 0) {
      clearInterval(interval);
    }
    await loadEPUBDownloadUrl();
  }, 2000);
});
loadEPUBDownloadUrl();
const epubUrl = ref<string>('');
const canDownloadExternalEpub = ref(false);
const checkingIfCanDownloadExternalEpub = ref(false);
/**
 * Check if the epub is available for download via BokInfo
 */
const checkCanDownloadExternalEpub = async () => {
  checkingIfCanDownloadExternalEpub.value = true;
  if (props.item?.isbn) {
    const urlObj = await downloadExternalContent(props.item.isbn, 'epub', props.id);
    if (urlObj) {
      canDownloadExternalEpub.value = urlObj.url.length > 0;
      epubUrl.value = urlObj.url;
      eventBus.$emit('snackbar.open', 'Epub found for download');
    } else {
      eventBus.$emit('snackbar.open', 'No available ePub found');
    }
  }
  checkingIfCanDownloadExternalEpub.value = false;
};

const uploadEpubFromUrl = async () => {
  const urlObj = await downloadExternalContent(props.item.isbn, 'epub', props.id, false);
  eventBus.$emit('snackbar.open', urlObj?.status ?? 'Failed to upload ePub');
};
const externalDownloadButtonText = computed<string>(() =>
  canDownloadExternalEpub.value ? 'Download external ePub' : 'Search for external ePub',
);
const externalDownloadButtonClicked = () => {
  if (canDownloadExternalEpub.value) {
    return uploadEpubFromUrl();
  }
  return checkCanDownloadExternalEpub();
};

return { __sfc: true,uploadInProgress, uploadMedia, downloadMediaUrl, props, file, epubLink, acceptedFileType, isChanged, changeHandler, extractCover, upload, loadEPUBDownloadUrl, epubUrl, canDownloadExternalEpub, checkingIfCanDownloadExternalEpub, checkCanDownloadExternalEpub, uploadEpubFromUrl, externalDownloadButtonText, externalDownloadButtonClicked, DisableableButton, DropFile }
}

})